// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__t0zGd","list":"styles_list__3T6rL"};